import React from 'react'
import { Button } from '../common'
import { useState } from 'react'
import { BusqueCidadeEstadoBairro } from '../BusqueCidadeEstadoBairro/index'
import { cleanSelectedArgumentsForAutocomplete, isValidStr } from '../../common_functions'
import SkeletonLoading from '../common/SkeletonLoading'
import ModalFilter from '../Modais/ModalFilter'
import {
  FILTER_BATHROOMS,
  FILTER_DIFFERENTIALS,
  FILTER_LIST_STATUS,
  FILTER_NUMBER_BEDROOMS,
  FILTER_PARKING_SPACES,
  FILTER_SUIT,
  FILTER_area_MAX,
  FILTER_area_MIN,
  FULL_TEXT
} from '../../constants/storageNames'

interface Props {
  isMobile?: boolean
}

export function SearchBar({ isMobile = false }: Props) {
  const [showModalFilter, setShowModalFilter] = useState(false)

  const handleSearch = () => {
    let input =
      document.querySelectorAll('#enderecoBuscaEmpreendimento').length > 1
        ? document.querySelectorAll('#enderecoBuscaEmpreendimento')[1]
        : document.querySelectorAll('#enderecoBuscaEmpreendimento')[0]

    let fullText = ''
    if (window.screen.width >= 768) {
      fullText = (document.querySelector('#enderecoBuscaEmpreendimento') as HTMLInputElement).value
    } else {
      fullText = (input as HTMLInputElement).value
    }

    fullText = getFullTextFilter(!isValidStr(fullText) ? 'Empreendimentos ' : fullText)

    let searchUrl = ''
    if (isValidStr(fullText)) {
      searchUrl = `?search=enterprises&fullText=${fullText}`
    }
    // cleanSelectedArgumentsForAutocomplete()
    window.location.href = `/busca/${searchUrl}`
  }

  const getFullTextFilter = (argument: string) => {
    const filterNUMBER_BEDROOMS = sessionStorage.getItem(FILTER_NUMBER_BEDROOMS)
    const filterBATHROOMS = sessionStorage.getItem(FILTER_BATHROOMS)
    const filterPARKING_SPACES = sessionStorage.getItem(FILTER_PARKING_SPACES)
    const filterSUIT = sessionStorage.getItem(FILTER_SUIT)
    const filterarea_MIN = sessionStorage.getItem(FILTER_area_MIN)
    const filterarea_MAX = sessionStorage.getItem(FILTER_area_MAX)
    const filterDIFFERENTIALS = sessionStorage.getItem(FILTER_DIFFERENTIALS)
    const filterSTATUSLIST = sessionStorage.getItem(FILTER_LIST_STATUS)

    let fullText = argument
    if (isValidStr(filterSTATUSLIST?.toString())) {
      fullText += ' ' + filterSTATUSLIST?.replaceAll(',', ' ou ') + ''
    }
    if (isValidStr(filterNUMBER_BEDROOMS?.toString())) {
      fullText += ', ' + parseInt(filterNUMBER_BEDROOMS ?? '') + ' quartos'
      if (filterBATHROOMS?.includes('+')) {
        fullText += ' ou mais'
      }
    }
    if (isValidStr(filterBATHROOMS?.toString())) {
      fullText += ', ' + parseInt(filterBATHROOMS ?? '') + ' banheiros'
      if (filterBATHROOMS?.includes('+')) {
        fullText += ' ou mais'
      }
    }
    if (isValidStr(filterPARKING_SPACES?.toString())) {
      fullText += ', ' + parseInt(filterPARKING_SPACES ?? '') + ' vagas'
      if (filterBATHROOMS?.includes('+')) {
        fullText += ' ou mais'
      }
    }
    if (isValidStr(filterSUIT?.toString())) {
      fullText += ', ' + parseInt(filterSUIT ?? '') + ' suítes'
      if (filterBATHROOMS?.includes('+')) {
        fullText += ' ou mais'
      }
    }
    if (isValidStr(filterarea_MIN?.toString())) {
      fullText += ', no mínimo ' + filterarea_MIN + ' m2'
    }
    if (isValidStr(filterarea_MAX?.toString())) {
      fullText += ', no máximo ' + filterarea_MAX + ' m2'
    }
    if (isValidStr(filterDIFFERENTIALS?.toString())) {
      fullText += ' com ' + filterDIFFERENTIALS?.replace(',', ', ').toLowerCase()
    }
    return fullText
  }

  const handleFilter = () => {
    const filterHTML = document.querySelector(
      isMobile ? '#sectionFilterMobile' : '#sectionFilter'
    ) as HTMLElement
    if (filterHTML != undefined) {
      filterHTML.classList.toggle('hidden')
    }
  }

  return (
    <div className="max-w-lg gap-4">
      <div className="flex gap-2 search-bar">
        <>
          <BusqueCidadeEstadoBairro />
        </>
        <Button
          variant="primary"
          id="filterBtnNavDesktop"
          aria-label="Buscar"
          value="Buscar"
          className='aspect-square'
          onClick={handleSearch}
        >
          <>
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_8760_453)">
                <path
                  d="M13.9999 13.6755L10.347 10.0227C11.2959 8.86221 11.7624 7.38141 11.6501 5.8866C11.5378 4.3918 10.8552 2.99734 9.74363 1.99166C8.63201 0.985992 7.17638 0.446048 5.67783 0.483517C4.17927 0.520985 2.75245 1.133 1.69248 2.19297C0.632509 3.25294 0.0204952 4.67976 -0.0169734 6.17832C-0.0544419 7.67687 0.485502 9.1325 1.49117 10.2441C2.49685 11.3557 3.89131 12.0383 5.38611 12.1506C6.88092 12.2629 8.36172 11.7964 9.5222 10.8475L13.175 14.5004L13.9999 13.6755ZM5.8332 11.0004C4.91022 11.0004 4.00797 10.7267 3.24054 10.2139C2.47311 9.70111 1.87498 8.97227 1.52177 8.11955C1.16856 7.26683 1.07614 6.32852 1.25621 5.42327C1.43627 4.51803 1.88073 3.68651 2.53337 3.03386C3.18602 2.38122 4.01754 1.93676 4.92278 1.7567C5.82803 1.57663 6.76634 1.66905 7.61906 2.02226C8.47178 2.37547 9.20062 2.9736 9.7134 3.74103C10.2262 4.50846 10.4999 5.41071 10.4999 6.33369C10.4985 7.57094 10.0064 8.75712 9.1315 9.63199C8.25663 10.5069 7.07045 10.999 5.8332 11.0004Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_8760_453">
                  <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                </clipPath>
              </defs>
            </svg>
          </>
        </Button>
      </div>
      {!location.pathname.includes('/perfil') && <div className='mt-3'>
        <Button
          variant="secondary"
          aria-label="Filtrar"
          id="openSectionFilter"
          value="Filtrar"
          className={`${isMobile ? 'order-2' : ''} w-full`}
          onClick={handleFilter}
        >
          <span>Filtros</span>
          <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.78573 9.02344H0.928589M18.0714 14.7377L15.2143 14.7377M18.0714 3.30915L10.6429 3.30916M8.35716 3.30915L0.92859 3.30915M6.07145 9.02344L18.0714 9.02344M12.9286 14.7377H0.92859M12.9286 12.452V17.0234L15.2143 17.0234V12.452L12.9286 12.452ZM3.78573 6.73772V11.3092H6.07145V6.73772H3.78573ZM8.35716 1.02344V5.59487H10.6429V1.02344L8.35716 1.02344Z"
              stroke="#0059FF"
            />
          </svg>
        </Button>
      </div>}
      {showModalFilter && (
        <ModalFilter show={showModalFilter} close={() => setShowModalFilter(false)} />
      )}
    </div>
  )
}
